import { ColDef, ColGroupDef, GridOptions } from 'ag-grid-community'
import { ClearingHouseDetail } from 'api'
import { Translation, Locale } from 'locale'
import {
  gridOptionsBase,
  TypedValueGetterParams,
  withAllContext,
  createActionsRenderer,
  createGroupedActionRenderer,
  StatusCellRenderer
} from 'view/components/datagrid'
import { getEntityStatusColor, getEntityStatusEnabledDisabledText } from 'view/shared/datagrid'
import { ClearingHouseActionsButton } from './ClearingHouseActionsButton'

enum ClearingHouseGridColumnId {
  CLEARING_HOUSE_ACTIONS = 'CLEARING_HOUSE_ACTIONS',
  CLEARING_HOUSE_STATUS = 'CLEARING_HOUSE_STATUS',
  CLEARING_HOUSE_NAME = 'CLEARING_HOUSE_NAME',
  CLEARING_HOUSE_MIC = 'CLEARING_HOUSE_MIC',
  CLEARING_HOUSE_LEI = 'CLEARING_HOUSE_LEI',
  CLEARING_HOUSE_BIC = 'CLEARING_HOUSE_BIC'
}

export const ClearingHouseColumnDefs: (ColGroupDef | ColDef)[] = [
  {
    colId: ClearingHouseGridColumnId.CLEARING_HOUSE_ACTIONS,
    headerName: Locale.translate(Translation.TC_EMPTY_HEADER),
    equals: () => false,
    width: 130,
    minWidth: 130,
    headerComponent: withAllContext(createGroupedActionRenderer(ClearingHouseActionsButton)),
    cellClass: 'action-cell',
    cellRenderer: withAllContext(createActionsRenderer(ClearingHouseActionsButton)),
    pinned: 'left',
    lockPinned: true,
    enableRowGroup: false,
    lockVisible: true,
    filter: false,
    sortable: false
  },
  {
    colId: ClearingHouseGridColumnId.CLEARING_HOUSE_STATUS,
    valueGetter: (params: TypedValueGetterParams<ClearingHouseDetail>) =>
      params.data && getEntityStatusEnabledDisabledText(params.data.clearingHouse.status),
    headerName: Locale.translate(Translation.TC_STATUS),
    width: 120,
    filter: 'agSetColumnFilter',
    cellRenderer: StatusCellRenderer,
    cellRendererParams: {
      getStatusColor: (data: ClearingHouseDetail) => getEntityStatusColor(data.clearingHouse.status)
    },
    equals: () => false,
    lockVisible: true,
    lockPosition: true
  },
  {
    colId: ClearingHouseGridColumnId.CLEARING_HOUSE_NAME,
    valueGetter: (params: TypedValueGetterParams<ClearingHouseDetail>) => params.data && params.data.clearingHouse.publishedName,
    headerName: Locale.translate(Translation.TC_PUBLISHED_NAME),
    width: 150,
    filter: 'agSetColumnFilter'
  },
  {
    colId: ClearingHouseGridColumnId.CLEARING_HOUSE_MIC,
    valueGetter: (params: TypedValueGetterParams<ClearingHouseDetail>) => params.data && params.data.clearingHouse.marketIdentifierCode,
    headerName: Locale.translate(Translation.TC_CLEARING_HOUSE_MIC),
    width: 120,
    filter: 'agSetColumnFilter'
  },
  {
    colId: ClearingHouseGridColumnId.CLEARING_HOUSE_LEI,
    valueGetter: (params: TypedValueGetterParams<ClearingHouseDetail>) => params.data && params.data.clearingHouse.lei,
    headerName: Locale.translate(Translation.TC_CLEARING_HOUSE_LEI),
    width: 120,
    filter: 'agSetColumnFilter'
  },
  {
    colId: ClearingHouseGridColumnId.CLEARING_HOUSE_BIC,
    valueGetter: (params: TypedValueGetterParams<ClearingHouseDetail>) => params.data && params.data.clearingHouse.bic,
    headerName: Locale.translate(Translation.TC_CLEARING_HOUSE_BIC),
    width: 120,
    filter: 'agSetColumnFilter'
  }
]

export const clearingHouseGridOptions: GridOptions = {
  ...gridOptionsBase,
  groupDefaultExpanded: 0,
  getRowId: ({ data }) => data.clearingHouse.id
}
